/* SOS ORIGINAL - header fijo con vidrio + marquee (todas las paginas) */
(function(){
  function fixHeader(){
    var secs = document.querySelectorAll('.shopify-section-group-header-group');
    if(!secs.length) return;
    var top = 0;
    secs.forEach(function(s){
      s.classList.add('sos-fixed-header');
      s.style.position = 'fixed';
      s.style.top = top + 'px';
      s.style.left = '0';
      s.style.right = '0';
      s.style.zIndex = '100';
      top += s.offsetHeight;
    });
    /* en el home el hero pasa por debajo del vidrio; en las demas paginas
       compensamos la altura para que el contenido no quede oculto */
    var esHome = !!document.querySelector('.sos-campaign--sticky');
    document.body.style.paddingTop = esHome ? '0' : (top + 'px');
    document.documentElement.style.setProperty('--sos-header-h', top + 'px');
  }
  function marquee(){
    var msg = document.querySelector('.announcement-bar__message');
    if(!msg || msg.dataset.sosMarquee) return;
    msg.dataset.sosMarquee = '1';
    var text = msg.textContent.trim();
    if(!text) return;
    var bar = msg.closest('.announcement-bar') || msg.parentElement;
    if(bar){ bar.classList.add('sos-marquee'); }
    var track = document.createElement('div');
    track.className = 'sos-marquee-track';
    for(var i=0;i<8;i++){
      var sp = document.createElement('span');
      sp.textContent = text;
      track.appendChild(sp);
    }
    msg.innerHTML = '';
    msg.appendChild(track);
  }
  function init(){ marquee(); fixHeader(); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('resize', fixHeader);
})();